(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/login-iam/assets/javascripts/utils/dialogs.js') >= 0) return;  svs.modules.push('/modules/login-iam/assets/javascripts/utils/dialogs.js');

'use strict';

const {
  dialog: dialogComp
} = svs.components;
const {
  logger
} = svs.login_iam;
const {
  route
} = svs.login_iam.constants;

const showDialog = function (title, errorMessage) {
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  return new Promise(resolve => {
    title = title || 'Tekniskt fel';
    errorMessage = errorMessage || 'Något gick fel. Vänligen försök igen senare.';
    const dialog = new dialogComp.Confirm({
      branding: dialogComp.branding.SPORT,
      icon: 'exclamation-sign',
      area: dialogComp.area.POPUP,
      type: dialogComp.type.ERROR,
      title,
      message: [{
        type: dialogComp.message.TEXT,
        text: errorMessage,
        align: dialogComp.message.align.CENTER
      }],
      actions: [{
        title: 'Okej',
        callback: () => {
          callback();
          dialog.close();
          resolve();
        }
      }]
    });
    dialogComp.api.add(dialog);
  });
};

const showDialogExtended = function (title, message) {
  let icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'exclamation-sign';
  let type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : dialogComp.type.ERROR;
  let actions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  return new Promise(resolve => {
    if (actions.length === 0) {
      actions = [{
        title: 'Okej',
        callback: () => {
          dialog.close();
          resolve(1);
        }
      }];
    } else {
      actions = actions.map(action => ({
        title: action.title,
        callback: () => {
          dialog.close();
          resolve(action.resolveValue);
        }
      }));
    }

    if (!Array.isArray(message)) {
      if (typeof message === 'string' && message.length > 0) {
        message = [{
          type: dialogComp.message.TEXT,
          text: message,
          align: dialogComp.message.align.CENTER
        }];
      } else {
        message = [];
      }
    }
    const dialog = new dialogComp.Confirm({
      branding: dialogComp.branding.SPORT,
      icon,
      area: dialogComp.area.POPUP,
      type,
      title,
      message,
      actions
    });
    dialogComp.api.add(dialog);
  });
};
const handleShowChangeToBankId = history => {
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.SPORT,
    icon: 'help',
    area: dialogComp.area.POPUP,
    title: 'Vill du logga in med BankId istället',
    actions: [{
      title: 'Nej tack',
      callback: () => {
        history.push(route.LOGIN_FREJAEID_ROUTE);
        dialog.close();
      }
    }, {
      title: 'Ja det vill jag',
      callback: () => {
        history.push(route.LOGIN_BANKID_ROUTE);
        dialog.close();
      }
    }]
  });
  dialogComp.api.add(dialog);
};
const handleShowChangeToFrejaEId = history => {
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.SPORT,
    icon: 'help',
    area: dialogComp.area.POPUP,
    title: 'Vill du logga in med Freja eID istället',
    actions: [{
      title: 'Nej tack',
      callback: () => {
        history.push(route.LOGIN_BANKID_ROUTE);
        dialog.close();
      }
    }, {
      title: 'Ja det vill jag',
      callback: () => {
        history.push(route.LOGIN_FREJAEID_ROUTE);
        dialog.close();
      }
    }]
  });
  dialogComp.api.add(dialog);
};
const handleShowFrejaEidError = history => {
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.SPORT,
    icon: 'exclamation-sign',
    area: dialogComp.area.POPUP,
    type: dialogComp.type.ERROR,
    title: 'Misslyckad inloggning',
    message: [{
      type: dialogComp.message.TEXT,
      text: 'Ett fel har uppstått när du försökte logga in.',
      align: dialogComp.message.align.CENTER
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        handleShowChangeToBankId(history);
        dialog.close();
      }
    }]
  });
  dialogComp.api.add(dialog);
};

const handleShowBankIdErrorCode = async (history, errorCode, isSameDevice) => {
  let title = 'Misslyckad inloggning';
  let errorMessage = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
  const frejaCB = () => handleShowChangeToFrejaEId(history);
  let callback = () => {};
  switch (errorCode) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      callback = frejaCB;
      break;
    case 6: 
    case 31:
      errorMessage = 'För ytterligare information vänligen kontakta Svenska Spels kundservice på telefon 0770-11 11 11';
      break;
    case 8:
    case 9:
    case 10:
    case 12:
    case 13:
    case 14:
    case 15:
    case 18:
    case 19:
    case 20:
    case 41:
    case 42:
    case 43:
    case 46:
    case 47:
    case 48:
    case 49:
    case 53:
    case 54:
    case 55:
      callback = frejaCB;
      break;
    case 56:
      errorMessage = isSameDevice ? 'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning.' + ' Om du inte har något giltigt BankID kan du hämta ett hos din internetbank. Försök sedan igen.' : 'Du har väntat för länge med att starta din BankID-app, var vänlig försök att logga in igen.';
      callback = frejaCB;
      break;
    case 7:
    case 11:
    case 16:
    case 17:
      errorMessage = 'Det går inte att logga in just nu, var vänlig kontakta Kundservice 0770 - 11 11 11';
      callback = frejaCB;
      break;
    case 22:
      errorMessage = 'Ups! Vår slagning mot Spelpaus.se för att se om du är spelpausad eller ej gav inget svar. Vänligen försök igen. Vid frågor, ring Svenska Spels Kundservice, 0770 - 11 11 11';
      break;
    case 44:
      errorMessage = 'Det går inte att logga in just nu, prova att uppdatera BankID appen.';
      break;
    case 45:
      errorMessage = 'Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller hämta ett nytt hos din internetbank';
      callback = frejaCB;
      break;
    case 50:
      errorMessage = 'Inloggningen avbruten, var vänlig försök igen';
      break;
    case 51:
    case 52:
      logger.debug("Login aborted by user ".concat(errorCode));
      title = 'Inloggning avbruten';
      errorMessage = 'Du har avbrutit din inloggning';
      break;
    default:
      logger.info("Unhandled login error: ".concat(errorCode));
      callback = frejaCB;
  }
  await showDialog(title, errorMessage, callback);
};
svs.login_iam.utils.Dialogs = {
  handleShowFrejaEidError,
  handleShowBankIdErrorCode,
  showDialog,
  showDialogExtended
};

 })(window);